import { defineComponent as _defineComponent } from 'vue'
import {useUserStore} from "@/store/user.store";
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import {onMounted, ref} from "vue";
import {FaucetErrorEnum} from "@/models/faucet";
import { useChallengeV2 } from 'vue-recaptcha/head';



export default /*#__PURE__*/_defineComponent({
  __name: 'FaucetView',
  setup(__props, { expose: __expose }) {
  __expose();


onMounted(async () => {
  address.value=userStore.connectionInfo.account;

});
const toast = useToast();
const i18n = useI18n();
const userStore = useUserStore();
const address = ref<string>('');
const recaptchaToken = ref<string>('');

const { root, onVerify, reset } = useChallengeV2({
  options: {
    theme: 'light',
    size: 'normal',
  }
});

onVerify((response: string) => {
  recaptchaToken.value = response;
});

function topup() {
  useUserStore().topUpAccount(address.value, recaptchaToken.value,
    () => {
      toast.success(i18n.t('TOAST.SUCCESS.TOP_UP'));
      resetReCaptcha();
    },
    (errorType: FaucetErrorEnum) => {
      if(errorType == FaucetErrorEnum.UNKNOWN) {
        toast.error(i18n.t('TOAST.ERROR.TOP_UP'));
      } else if(errorType == FaucetErrorEnum.TOO_MANY_REQUESTS) {
        toast.error(i18n.t('TOAST.ERROR.TOO_MANY_REQUESTS'));
      }
      resetReCaptcha();
    });
}

const resetReCaptcha = () => {
  reset();
  recaptchaToken.value = '';
};


const __returned__ = { toast, i18n, userStore, address, recaptchaToken, root, onVerify, reset, topup, resetReCaptcha }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})